<script>
import axios from 'axios';
import Select from './Select.vue';
import MixinsVue from '../mixins/Vue.js';

export default {
    extends: Select,
    components: {
        Select,
    },
    props: {
        originalInputPlaceholderText: String,
        dropdownContainerId: String,
        user: Object,
        currenciesJson: {
            type: String,
            default: null,
        },
        customSelectInputName: {
            type: String,
            default: null,
        },
    },
    data() {
        let currencies = [];
        let hasBeenLoaded = false;

        if (this.currenciesJson != null) {
            this.options = currencies = JSON.parse(this.currenciesJson);
            hasBeenLoaded = true;
        }

        return {
            mixins: MixinsVue.methods.vue,
            options: [],
            currencies: currencies,
            selectedCurrency: null,
            selectInputName: this.customSelectInputName ?? 'select-currency',
            selectOption: 'select-currency',
            hasBeenLoaded: hasBeenLoaded,
            token: document.querySelector('meta[name="csrf-token"]').content,
        };
    },
    computed: {
        inputPlaceholderText: function () {
            let userCurrency = window.app.getSelectedCurrency();
            // Avoid displaying non available currency.
            if (
                !this.currencies.some(
                    (currency) => currency.code === userCurrency.code
                )
            ) {
                return;
            }

            let selectPlaceholder = userCurrency.code;
            selectPlaceholder += ' (';
            selectPlaceholder += userCurrency.name;
            selectPlaceholder += ')';
            return selectPlaceholder;
        },
    },
    mounted() {
        // Activate hidden input
        this.hiddenInput = true;
        // hiddenInputValue default is false
        this.hiddenInputValue = false;
        this.loadCurrencies();
    },
    watch: {
        selectInputValue(value) {
            this.filterOptions(value);
        },

        hiddenInput(isHidden) {},
    },
    methods: {
        select(currency) {
            this.selectedCurrency = currency;
            this.selectInputValue = this.optionLabel(currency);
            this.hiddenInputValue = true;
            Select.methods.select.call(this, currency);
        },
        optionLabel(option) {
            let label = option.code;
            label += ' (';
            label += option.name;
            label += ')';
            return label;
        },
        loadCurrencies() {
            // Avoid loading currencies several times
            if (!this.hasBeenLoaded) {
                axios
                    .get('/api/currencies', {
                        headers: {
                            'X-CSRF-TOKEN': this.token,
                        },
                    })
                    .then(
                        (success) => {
                            this.options = this.currencies = success.data.data;
                            this.hasBeenLoaded = true;
                        },
                        (error) => {
                            // Log error on the console for debug purpose
                            console.error(error.response.status);
                            console.error(error.message);
                            console.error(error.response.data);
                            console.error(error.response.headers);
                        }
                    );
            }
        },
        filterOptions(string) {
            // Allow currencies filtering when typing in the select input
            string = string && string.trim();
            if (!string) {
                this.options = this.currencies;
            } else {
                string = this.app.string.slugify(string);
                this.options = this.currencies.filter((currency) => {
                    // Ignore special chars.
                    let label = this.app.string.slugify(
                        this.optionLabel(currency)
                    );
                    return !currency.id || label.indexOf(string) !== -1;
                });
            }
        },
    },
};
</script>
